export default {
	data(){
		return {
			tableGBoptions: { 
				options: { anular: 'Anular Autorización'},
				modals: [
					{
						modal: "Autorizar",
						variant: "info",
						icon: "check-circle",
						title: "Autorizar"
					},
				]
			},

			tableGBSearch: ['list_users/name'],
			
			tableGBItems: [				
				{
					thead: { th: 'Radicador', sort: null, sortTable: 'list_users/name'},
					tbody: { td: ['list_users/name'],}
				},
				{
					thead: { th: 'Tipo', },
					tbody: { td: ['autorizar/eliminar'],}
				},
				{
					thead: { th: 'Motivo', },
					tbody: { td: ['autorizar/nota'],}
				},
			]			
		}
	},
}